import type { ReactNode } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { WidgetTableProps } from '@/components/WidgetTable/types';
import { QueryTable } from './QueryTable';
import { cn } from '@/lib/utils';

type QueryTableDialogProps<T> = {
  /** Dialog control */
  open: boolean;
  onOpenChange: (open: boolean) => void;

  /** Header */
  title: ReactNode;

  /** Data */
  query: UseQueryResult<T[]>;
  columns: WidgetTableProps<T>['columns'];

  /** Optional table behavior */
  onRowClick?: (row: T) => void;
  emptyState?: string;
  loadingState?: ReactNode;

  /** Layout */
  contentClassName?: string;
};

export function UserListModal<T>({
  open,
  onOpenChange,
  title,
  query,
  columns,
  onRowClick,
  emptyState,
  loadingState,
  contentClassName = 'max-w-4xl',
}: QueryTableDialogProps<T>) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn('max-h-[80vh] flex flex-col', contentClassName)}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="mt-4 min-h-0 h-[300px] flex flex-col">
          <QueryTable<T>
            query={query}
            columns={columns}
            onRowClick={onRowClick}
            emptyState={emptyState}
            loadingState={loadingState}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
